export function useInitData() {
  const parseIdFromProductPath = () => {
    if (window.location.pathname === "/products/create") {
      return false;
    }

    const searchParams = new URLSearchParams(window.location.search);

    const suggestionParam = searchParams.get("suggestion");

    if (suggestionParam) {
      return suggestionParam;
    }

    const hasId = window.location.pathname.replace(
      /\/product\/(\[aZ-09]+)?/,
      ""
    );

    if (hasId) {
      return hasId.replace("/", "");
    }
  };
  return parseIdFromProductPath;
}
export function useProductData() {
  const adaptProductData = (product) => {
    const newData = {
      id: product.id,
      barcode: product.sellable.barcode || "",
      name: product.sellable.name,
      ref_code: product.sellable.code || product.sellable.internal_code,
      price: product.sellable.price || 0,
      cost: product.sellable.cost || 0,
      unit: product.sellable.unit.id || null,
      notes: product.sellable.notes || "",
    };

    if (product.stock.quantity) {
      newData.stock_quantity = product.stock.quantity;
    }
    if (product.sellable.category.id) {
      newData.category = product.sellable.category.id;
    }
    if (product.fiscal_data.ncm) {
      const fiscal = {
        ncm: product.fiscal_data.ncm.id,
        cfop: product.fiscal_data.cfop.id,
        template_icms: product.fiscal_data.template_icms.id,
      };
      newData.ncmCode = product.fiscal_data.ncm.code;
      newData.ncmDescription = product.fiscal_data.ncm.description;
      newData.cfopCode = product.fiscal_data.cfop.code;
      newData.cfopDescription = product.fiscal_data.cfop.description;
      newData.ANPCode = product.fiscal_data.anp_code;
      newData.ANPDescription = product.fiscal_data.anp_description;

      newData.icms = product.fiscal_data.template_icms.id;

      if (product.fiscal_data.template_ipi.id) {
        newData.ipi = product.fiscal_data.template_ipi.id;
      }
      if (product.fiscal_data.template_pis.id) {
        newData.pis = product.fiscal_data.template_pis.id;
      }
      if (product.fiscal_data.template_cofins.id) {
        newData.cofins = product.fiscal_data.template_cofins.id;
      }
      newData.fiscal = fiscal;
    }
    return newData;
  };
  return adaptProductData;
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Products/Product/hooks/index.js